module.exports = __webpack_public_path__ + "static/media/diritto-immobiliare.38d34bed.jpg";